import { PLATFORM, ParamsType, ICallHistoryMenu } from 'rcx_adapter';
import i18n from 'rcx_i18n';

import { BaseModule } from './BaseModule';
import Config from '../../config/app.config';
import { LOGGING_TYPE } from '../constants';
import { defaultHistoryMenuConfig, incidentHistoryMenuConfig } from '../constants/historyMenuConfig';
import { ServiceNowAdapterEvent } from '../enums';
import { ModuleBaseOption } from '../interfaces/module';
import { Token } from '../lib/Token';

const packageJson = require('../../package.json');

class CommonModule extends BaseModule<ModuleBaseOption> {
    private popIdMap: Map<string, string> = new Map();
    public start(): void {
        if (this.getIsInit()) {
            this.listenFromRCX();
            this.listenFromSN();
            window.parent.postMessage({ type: 'request_user_info' }, '*');
        }
    }
    private listenFromRCX() {
        this.mRCXAdapter!.onViewLog((data) => {
            const callLog = data.crmLink?.crmCallLog;
            const chatLog = data.crmLink?.crmChatLog;
            const logId = callLog?.id || chatLog?.id;

            if (!logId) return;

            const paramsType = callLog?.id ? ParamsType.CALL : ParamsType.CHAT;
            this.mServiceNowAdapter?.getLogAdapter().viewLog(paramsType, logId, data.crmLink?.crmLoggingType);
        });
        this.mRCXAdapter!.onIntegrationHasLogin(async ({ agentSettings } = {}) => {
            this.mServiceNowAdapter!.getStateSyncAdapter()?.setAvailableAgentStates(
                agentSettings?.availableAgentStates || []
            );
            // if agentId is not empty and it is first time get into eag, then set agentUIUrl to localStorage
            if (agentSettings?.agentId) {
                localStorage.setItem(
                    'agentUIUrl',
                    `${Config.envUrl}/voice/agent/?rcx_client_app_type=RCX_SERVICE_NOW&rcx_client_app_version=${
                        packageJson.version || ''
                    }&agentId=${agentSettings.agentId}`
                );
            }
            const result = await this.mServiceNowAdapter!.authorize();
            if (result.success) {
                this.mServiceNowAdapter!.getVersion().then((version) => {
                    // @ts-ignore
                    window[Symbol.for('rcx_sentry')]?.setTags({
                        snReleaseVersion: version,
                    });
                });
                await this.mServiceNowAdapter!.getRingCXForServiceNowConfig();
                const callLoggingType = this.mServiceNowAdapter!.getCallLoggingType();

                this.mRCXAdapter!.sendIntegrateInformation({
                    platform: PLATFORM.SERVICE_NOW,
                    callLoggingType: callLoggingType,
                    callHistoryMenu:
                        callLoggingType === LOGGING_TYPE.INCIDENT
                            ? this.generateMenuFromConfig(incidentHistoryMenuConfig)
                            : this.generateMenuFromConfig(defaultHistoryMenuConfig),
                    digitalHistoryMenu: this.generateMenuFromConfig(defaultHistoryMenuConfig),
                });
                this.mServiceNowAdapter!.getStateSyncAdapter()?.getPresenceState();
                await this.mServiceNowAdapter!.getStateSyncAdapter()?.getServiceChannel();
                await this.mServiceNowAdapter!.getStateSyncAdapter()?.getPresenceStates();
                this.mServiceNowAdapter!.getStateSyncAdapter()?.getStatesSyncMap();
            }
            this.mServiceNowAdapter!.emit(ServiceNowAdapterEvent.UPDATE_SECOND_IFRAME_STATUS, true);
        });

        this.mRCXAdapter!.onIntegrationHasLogout(() => {
            this.mServiceNowAdapter!.emit(ServiceNowAdapterEvent.UPDATE_SECOND_IFRAME_STATUS, false);
        });
        this.mRCXAdapter!.onGetLocaleFromRCX(() => {
            this.mRCXAdapter!.sendLocaleInfoToRCX(navigator.language);
            this.mServiceNowAdapter!.emit(ServiceNowAdapterEvent.RESET_SECOND_IFRAME);
        });
    }

    private listenFromSN() {
        const token = new Token();
        window.addEventListener('message', function (event) {
            if (event.data.type === 'user_info') {
                const user = event?.data?.data || {};
                const currentUserId = localStorage.getItem('currentUserId');
                if (user.userID && currentUserId !== user.userID) {
                    localStorage.setItem('currentUserId', user.userID);
                    token.setData(null);
                }
            }
        });
    }

    private generateMenuFromConfig(config: Record<string, any>[]): ICallHistoryMenu[] {
        return config.map((item) => ({
            action: item?.action,
            label: i18n.t(item?.labelKey),
        }));
    }
}

export default new CommonModule();
